import React, { useEffect } from 'react';
import { useUser } from '../authentication';
import { useParams } from 'react-router-dom';
import { selfAssignTraining } from './api/selfAssignTraining';
import windowService from '../../services/windowService';
import { handleError } from '../../utils/apiUtils';
import styled from 'styled-components';
import { Color } from '../../app/StyleGuide';
import LoadingState from '../../components/LoadingState';

const NavBarLoadingState = styled.div`
  height: 60px;
  width: 100%;
  background-color: ${Color.Gray._90};
`;

export function AddToYourTraining() {
  const { user } = useUser();
  const { trainingId } = useParams<{ trainingId: string }>();

  useEffect(() => {
    if (user) {
      selfAssignTraining(trainingId, user.userId, user.lastSelectedAccount)
        .then((training: { type: 'TaskList' | 'Workflow'; instanceId: string }) => {
          if (training.type === 'TaskList') {
            windowService.redirectTo(`/training-steps/${training.instanceId}`);
          } else {
            windowService.redirectTo(`/training-steps/${training.instanceId}?isWorkflow=true`);
          }
        })
        .catch(handleError);
    }
  }, [user, trainingId]);
  return (
    <>
      <NavBarLoadingState />
      <LoadingState />
    </>
  );
}
